// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3hmFK","importantInfo":"styles_importantInfo__6SmPk"};